/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tokens: NonNullable<unknown> }} Private_Models_Fact_ContextInputs */



/**
* | output |
* | --- |
* | "{tokens} tokens" |
*
* @param {Private_Models_Fact_ContextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_fact_context = /** @type {((inputs: Private_Models_Fact_ContextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Fact_ContextInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.tokens} Tokens`)
	return /** @type {LocalizedString} */ (`${i?.tokens} tokens`)
});